import type { MultiMeterBarSegmentProps } from '../types/multi-meter-bar-chart.js';

export const Segment = (props: MultiMeterBarSegmentProps) => null;

Segment['displayName'] = 'MultiMeterBarChart.Segment';
